export const beginWithLettersThenNumbersAndLetters = new RegExp(/^[a-zA-Z][\w]*$/g);
